import { create } from 'zustand'

import type {
  TProductStoreAction,
  TProductStoreState,
} from '../types/product-store.type'

export const ProductStore = create<TProductStoreState & TProductStoreAction>(
  (set) => ({
    products: undefined,
    productIdSelected: undefined,
    currentPagination: 0,
    productImage: undefined,
    productHistory: undefined,
    defaultTabsProductDetails: 'dados',
    productPaginate: undefined,
    isActiveInfinityScroll: false,
    isOpenModalDetailsProduct: false,
    isOpenModalProductImage: false,
    productsInsertedInOrderToCalculation: [],
    actions: {
			clearProducts: () => set({ products: undefined, currentPagination: 0 }),
      setProductImage: (props) => set({ productImage: props }),
      setProductHistory: (props) => set({ productHistory: props }),
      setProducts: (products) => set({ products }),
      setDefaultTabsProductDetails: (props) =>
        set({
          defaultTabsProductDetails: props,
        }),
      setProductPaginate: (productPaginate) => set({ productPaginate }),
      setCurrentPagination: (props) => set({ currentPagination: props }),
      setProductIdSelected: (props) => set({ productIdSelected: props }),
      setIsActiveInfinityScroll: (props) =>
        set({ isActiveInfinityScroll: props }),
      setIsOpenModalProductImage: (props) =>
        set({ isOpenModalProductImage: props }),
      setIsOpenModalDetailsProduct: (props) =>
        set({
          isOpenModalDetailsProduct: props,
        }),
      setProductsInsertedInOrderToCalculation: (props) =>
        set({
          productsInsertedInOrderToCalculation: props,
        }),
    },
  }),
)

export const useProductStore = ProductStore
export const useProductStoreActions = ProductStore.getState().actions
